import React, { useState, useEffect } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

const AddPromoOffers = () => {
  const { t } = useTranslation();
  const [cartAmountFrom, setCartAmountFrom] = useState(0);
  const [cartAmountTo, setCartAmountTo] = useState(0);
  const [cartAmountTarget, setCartAmountTarget] = useState(0);
  const [freeProductsCount, setFreeProductsCount] = useState(1);
  const [errormsg, setErrormsg] = useState({});
  const [freeloading, setfreeLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [freeproducts, setfreeProducts] = useState([]);
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertMessage1, setAlertMessage1] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);
  const [status, setStatus] = useState("active");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedFreeCategories, setSelectedFreeCategories] = useState([]);
  const [checkedval, setCheckedval] = useState([]);
  const [checkedfreeval, setCheckedfreeval] = useState([]);
  const [checkedState, setCheckedState] = useState([]);
  const [checkedBandState, setCheckedBandState] = useState([]);
  const [checkedBand, setCheckedBand] = useState([]);
  const [checkedfreeState, setCheckedfreeState] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [errmessage, setErrMessage] = useState({});
  const [priceBandIds, setPriceBandIds] = useState([]);
  const [flexTitle, setFlexTitle] = useState("");
  const [tooltipMessage, setTooltipMessage] = useState("");
  const [useLatestTooltip, setUseLatestTooltip] = useState(false);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_promooffers")
  ) {
    window.location.href = "/unauthorized";
  }

  function cancelbtn(e) {
    e.preventDefault();
    window.location.href = "/promooffers";
    return false;
  }

  useEffect(() => {
    setCheckedState(new Array(products.length).fill(false));
    setCheckedval([]);
  }, [products]);

  useEffect(() => {
    let arry = [];
    {
      arry = new Array(freeproducts.length).fill(false);
    }
    setCheckedfreeState(arry);

    setfreeLoading(true);
    setCheckedfreeval([]);
  }, [freeproducts]);

  useEffect(() => {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    var priceCode = "PL1";
    let URL = `${BaseUrl}admin/productprice/${priceCode}`;
    http
      .get(URL)
      .then((response) => {
        let responseData = response.data.data;
        setProducts(responseData);
        setfreeProducts(responseData);
      })
      .catch((err) => {
        console.log(err);
        setLoading(true);
      });
    let URL1 = `${BaseUrl}admin/getpricebandids`;
    http
      .get(URL1)
      .then((response) => {
        let responseData = response?.data?.data;
        // Filter out duplicate price band IDs
        // Convert to a Set to remove duplicates
        // and then convert back to an array
        const uniquePriceBandIds = responseData.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) => t.accountPriceListId === item.accountPriceListId,
            ),
        );
        setPriceBandIds(uniquePriceBandIds);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(true);
      });
  }, []);
  // Map of category names to category IDs
  const categoryMap = {
    pizza: ["1"],
    pasta: ["10", "13", "11", "12"],
    desserts: ["14"]
  };

  const handleOnChange1 = (position, e) => {
    const updatedfreeCheckedState = checkedfreeState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedfreeval];
    if (e.target.checked) {
      updatedList = [...checkedfreeval, e.target.value];
    } else {
      updatedList.splice(checkedfreeval.indexOf(e.target.value), 1);
    }
    setCheckedfreeval(updatedList);
    setErrormsg((prev) => ({
      ...prev,
      checkedfreevalErr: updatedList.length > 0 ? "" : t("field_required_txt"),
    }));
    setCheckedfreeState(updatedfreeCheckedState);
  };

  const handleOnChangeBand = (position, e) => {
    const updatedCheckedState = checkedBandState.map((item, index) => {
      return index === position ? !item : item;
    });
    var updatedList = [...checkedBand];
    if (e.target.checked) {
      updatedList = [...checkedBand, e.target.value];
    } else {
      updatedList.splice(checkedBand.indexOf(e.target.value), 1);
    }
    setCheckedBand(updatedList);
    setCheckedBandState(updatedCheckedState);
  };

  const freeCountChange = (e) => {
    setFreeProductsCount(e.target.value);
    setErrormsg((prev) => ({ ...prev, freeProductsCountErr: "" }));
  };

  const messageHandleChange = (e) => {
    setAlertMessage(e.target.value);
    const value = e.target.value || "";
    setErrormsg((prev) => ({
      ...prev,
      messageErr: value.trim() ? "" : prev.messageErr,
    }));
  };

  const message1HandleChange = (e) => {
    setAlertMessage1(e.target.value);
    const value = e.target.value || "";
    setErrormsg((prev) => ({
      ...prev,
      message1Err: value.trim() ? "" : prev.message1Err,
    }));
  };

  const eventFromAmountHandleChange = (e) => {
    const value = e.target.value || "";
    setCartAmountFrom(value);
    setErrormsg((prev) => ({
      ...prev,
      cartAmountFromErr: value.trim() ? "" : prev.cartAmountFromErr,
    }));
  };

  const eventToAmountHandleChange = (e) => {
    const value = e.target.value || "";
    setCartAmountTo(value);
    setErrormsg((prev) => ({
      ...prev,
      cartAmountToErr: value.trim() ? "" : prev.cartAmountToErr,
    }));
  };

  const targetAmountHandleChange = (e) => {
    const value = e.target.value || "";
    setCartAmountTarget(value);
    setErrormsg((prev) => ({
      ...prev,
      cartAmountTargetErr: value.trim() ? "" : prev.cartAmountTargetErr,
    }));
  };

  const flexTitleHandleChange = (e) => {
    const value = e.target.value || "";
    setFlexTitle(value);
    setErrormsg((prev) => ({
      ...prev,
      flexTitleErr: value.trim() ? "" : prev.flexTitleErr,
    }));
  };

  const tooltipHandleChange = (e) => {
    const value = e.target.value || "";
    setTooltipMessage(value);
    setErrormsg((prev) => ({
      ...prev,
      tooltipErr: value.trim() ? "" : prev.tooltipErr,
    }));
  };

  const formvalidation = () => {
    let newErrors = {};
    let isValid = true;
    if (!cartAmountFrom) {
      newErrors.cartAmountFromErr = t("field_required_txt");
      isValid = false;
    }
    if (!cartAmountTo) {
      newErrors.cartAmountToErr = t("field_required_txt");
      isValid = false;
    }
    if (!alertMessage) {
      newErrors.messageErr = t("field_required_txt");
      isValid = false;
    }
    if (!alertMessage1) {
      newErrors.message1Err = t("field_required_txt");
      isValid = false;
    }
    if (!cartAmountTarget) {
      newErrors.cartAmountTargetErr = t("field_required_txt");
      isValid = false;
    }
    if (!checkedfreeval.length) {
      newErrors.checkedfreevalErr = t("field_required_txt");
      isValid = false;
    }
    if (!flexTitle) {
      newErrors.flexTitleErr = t("field_required_txt");
      isValid = false;
    }
    if (!tooltipMessage) {
      newErrors.tooltipErr = t("field_required_txt");
      isValid = false;
    }
    setErrormsg(newErrors);
    return isValid;
  };

  const handleLatestTooltipCheckbox = async (e) => {
    const checked = e.target.checked;
    setUseLatestTooltip(checked);
    if (checked) {
      try {
        const URL = BaseUrl + "admin/latestpromooffer";
        const response = await http.get(URL);
        const latestData = response?.data?.data;
        const newFlexTitle = latestData?.flexTitle || "";
        const newTooltipMessage = latestData?.tooltipMessage || "";
        setFlexTitle(newFlexTitle);
        setTooltipMessage(newTooltipMessage);
        setErrormsg((prev) => ({
          ...prev,
          flexTitleErr: newFlexTitle.trim() ? "" : prev.flexTitleErr,
          tooltipErr: newTooltipMessage.trim() ? "" : prev.tooltipErr,
        }));
      } catch (err) {
        console.log(err);
      }
    } else {
      setFlexTitle("");
      setTooltipMessage("");
      setErrormsg((prev) => ({
        ...prev,
        flexTitleErr: "",
        tooltipErr: "",
      }));
    }
  };

  const submitButton = (e) => {
    e.preventDefault();
    const isValid = formvalidation();
    if (isValid) {
      let payload = {
        cartAmountFrom: cartAmountFrom,
        cartAmountTo: cartAmountTo,
        cartAmountTarget: cartAmountTarget,
        FromDate: fromDate,
        ToDate: toDate,
        sortOrder: sortOrder,
        freeProductToAdd: checkedfreeval.toString(),
        freeProductQtyToAdd: freeProductsCount,
        Status: status,
        createdBy: JSON.parse(sessionStorage.getItem("authData")).adminName,
        message: alertMessage,
        message1: alertMessage1,
        PriceBandTobeExcluded: checkedBand.toString(),
        flexTitle: flexTitle,
        tooltipMessage: tooltipMessage,
      };
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let URL = BaseUrl + "admin/addpromooffers";
      http
        .post(URL, payload)
        .then((response) => {
          if (response.data.success === true) {
            const successMsg = t("cart_promo_offer_added_successfully_txt", {
              target: cartAmountTarget,
              from: cartAmountFrom,
              to: cartAmountTo,
            });
            setAlertPopup(true);
            setAlertMessage(successMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleFreeCategoryChange = (e) => {
    const { name, checked } = e.target;
    setSelectedFreeCategories((prevSelectedFreeCategories) => {
      if (checked) {
        // Add the category if it's checked
        return [...prevSelectedFreeCategories, name];
      } else {
        // Remove the category if it's unchecked
        return prevSelectedFreeCategories.filter((cat) => cat !== name);
      }
    });
  };

  const handleclick = () => {
    setExpanded(!expanded);
    setfreeLoading(false);
  };

  const getFilteredFreeProducts = () => {
    const selectedFreeCategoryIds = selectedFreeCategories
      .map((category) => categoryMap[category])
      .flat(); // Flatten the array to merge all IDs into one array
    // Filter products based on the selected category IDs
    return freeproducts.filter((prd) =>
      selectedFreeCategoryIds.includes(prd.categoryId),
    );
  };

  const filteredFreeProducts = getFilteredFreeProducts();

  return (
    <section className="dashboard-block">
      {alertPopup && (
        <div
          className="custom-alert-pop common_alert_popup"
          style={{ display: "block" }}
        >
          <div className="custom-alert-container">
            <div className="custom-alert-wrap">
              <div className="custom-alert-header">
                <h4>{t("alert_txt")}</h4>
              </div>
              <div className="custom-alert-body">
                <p>{alertMessage}</p>

                <div className="alert-buttons">
                  <a
                    onClick={(e) => cancelbtn(e)}
                    className="popup-alert-btn button"
                  >
                    {t("ok_txt")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <h1 className="checkout-title">{t("add_cart_based_promo_offer_txt")}</h1>
            <div className="right-table-outer-wrap">
              {isLoading ? (
                <div className="loading-buffer"></div>
              ) : (
                <form
                  method="post"
                  className="addform editform promo-form "
                  onSubmit={submitButton}
                >
                  <div className="input-field col-1">
                    <label>{t("cart_value_from_txt")}</label>
                    <input
                      type="text"
                      value={cartAmountFrom}
                      onChange={eventFromAmountHandleChange}
                      name="cartAmountFrom"
                      className="form-control"
                      placeholder={t("cart_from_amount_txt")}
                    />
                    {errormsg.cartAmountFromErr && (
                      <div className="error-msg">
                        {errormsg.cartAmountFromErr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label>{t("cart_value_to_txt")}</label>
                    <input
                      type="text"
                      value={cartAmountTo}
                      onChange={eventToAmountHandleChange}
                      name="cartAmountTo"
                      className="form-control"
                      placeholder={t("cart_to_amount_txt")}
                    />
                    {errormsg.cartAmountToErr && (
                      <div className="error-msg">
                        {errormsg.cartAmountToErr}
                      </div>
                    )}
                  </div>
                  <div className="input-field col-1">
                    <label>{t("target_cart_value_txt")}</label>
                    <input
                      type="text"
                      value={cartAmountTarget}
                      onChange={targetAmountHandleChange}
                      name="cartAmountTarget"
                      className="form-control"
                      placeholder={t("cart_target_amt_txt")}
                    />
                    {errormsg.cartAmountTargetErr && (
                      <div className="error-msg">
                        {errormsg.cartAmountTargetErr}
                      </div>
                    )}
                  </div>
                  <div className="input-field">
                    <div className="check-box" style={{ marginTop: "15px" }}>
                      <input
                        type="checkbox"
                        id="latestTooltip"
                        checked={useLatestTooltip}
                        onChange={handleLatestTooltipCheckbox}
                      />
                      <label htmlFor="latestTooltip">
                        {t("apply_existing_title_tooltip_txt")}
                      </label>
                    </div>
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">{t("flex_title_txt")}</span>
                    <input
                      type="text"
                      className="form-control"
                      value={flexTitle}
                      onChange={flexTitleHandleChange}
                      placeholder={t("enter_flex_title_txt")}
                      disabled={useLatestTooltip}
                    />
                    {errormsg.flexTitleErr && (
                      <div className="error-msg">{errormsg.flexTitleErr}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("target_before_notification_txt")}
                    </span>
                    <textarea
                      name="alertMessage"
                      className="form-control"
                      value={alertMessage}
                      onChange={messageHandleChange}
                    />
                    {errormsg.messageErr && (
                      <div className="error-msg">{errormsg.messageErr}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">
                      {t("target_after_notification_txt")}
                    </span>
                    <textarea
                      name="alertMessage1"
                      className="form-control"
                      value={alertMessage1}
                      onChange={message1HandleChange}
                    />
                    {errormsg.message1Err && (
                      <div className="error-msg">{errormsg.message1Err}</div>
                    )}
                  </div>
                  <div className="input-field">
                    <span className="labeltxt">{t("tooltip_message_txt")}</span>
                    <textarea
                      className="form-control"
                      value={tooltipMessage}
                      onChange={tooltipHandleChange}
                      disabled={useLatestTooltip}
                    />
                    {errormsg.tooltipErr && (
                      <div className="error-msg">{errormsg.tooltipErr}</div>
                    )}
                  </div>
                  {!loading && (
                    <div className="accordion-box input-field">
                      <div
                        onClick={handleclick}
                        className={
                          expanded === true
                            ? "accordion-header show"
                            : "accordion-header"
                        }
                      >
                        <h2>{t("free_product_txt")}</h2>
                        <span className="show-accordion"></span>
                      </div>
                      <div
                        className="accordion-body"
                        style={{
                          display: expanded === true ? "block" : "none",
                        }}
                      >
                        {!freeloading && (
                          <div className="custom_check-box">
                            <div className="edit-free-cat-disp">
                              <h4>
                                {t("select_free_product_txt")}
                              </h4>
                              <div className="edit-free-cat-chks">
                                <div className="check-box">
                                  <input
                                    type="checkbox"
                                    id="fcat01"
                                    name="pizza"
                                    onChange={handleFreeCategoryChange}
                                  />
                                  <label htmlFor="fcat01">{t("pizza_txt")}</label>
                                </div>
                                <div className="check-box">
                                  <input
                                    type="checkbox"
                                    id="fcat02"
                                    name="pasta"
                                    onChange={handleFreeCategoryChange}
                                  />
                                  <label htmlFor="fcat02">
                                    {t("pasta_txt")}
                                  </label>
                                </div>
                                <div className="check-box">
                                  <input
                                    type="checkbox"
                                    id="fcat04"
                                    name="desserts"
                                    onChange={handleFreeCategoryChange}
                                  />
                                  <label htmlFor="fcat04">{t("desserts_txt")}</label>
                                </div>
                              </div>
                              {filteredFreeProducts.map(
                                (prd, index) =>
                                  !checkedval.includes(prd.productNumber) && (
                                    <div className="check-box">
                                      <input
                                        type="checkbox"
                                        id={`freechkbox${index}`}
                                        name="freeprd_chkbox"
                                        value={prd.productNumber}
                                        checked={checkedfreeState[index]}
                                        onChange={(e) =>
                                          handleOnChange1(index, e)
                                        }
                                        disabled={
                                          prd.PDP_Status === "deactivate"
                                        }
                                      />
                                      <label htmlFor={`freechkbox${index}`}>
                                        {prd.productDescription}{" "}
                                        {"(" + prd.productNumber + ")"}
                                      </label>
                                    </div>
                                  ),
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                      {errormsg.checkedfreevalErr && (
                        <div className="error-msg">
                          {errormsg.checkedfreevalErr}
                        </div>
                      )}
                    </div>
                  )}
                  <br />
                  <div className="input-field">
                    <label>{t("free_products_count")}</label>
                    <input
                      type="text"
                      value={freeProductsCount}
                      name="freeProductsCount"
                      onChange={freeCountChange}
                      className="form-control"
                      placeholder={t("free_products_count")}
                    />
                    <div style={{ color: "red" }}>
                      {errmessage.freeProductsCountErr}
                    </div>
                  </div>
                  <div className="input-field">
                    <label>{t("priceband_exclude_txt")}</label>
                    <br /> <br />
                    {priceBandIds.map((priceBand, index) => (
                      <div
                        className="check-box"
                        style={{ display: "inline-block", width: "200px" }}
                      >
                        <input
                          type="checkbox"
                          name="PriceBandTobeExcluded"
                          id={`PriceBandTobeExcluded${index}`}
                          value={priceBand.accountPriceListId}
                          onChange={(e) => handleOnChangeBand(index, e)}
                          checked={checkedBandState[index]}
                        />
                        <label htmlFor={`PriceBandTobeExcluded${index}`}>
                          {priceBand.accountPriceListId}{" "}
                        </label>
                      </div>
                    ))}
                  </div>
                  <br /> <br />
                  {/* Status Dropdown */}
                  <div className="input-field">
                    <label className="full-width">{t("status_txt")}</label>
                    <select
                      className="col-4"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="active">{t("active_txt")}</option>
                      <option value="inactive">{t("inactive_txt")}</option>
                    </select>
                  </div>
                  <button title={t("submit_txt")} type="submit">{t("submit_txt")}</button> &nbsp;&nbsp;
                  <button title={t("cancel_txt")} onClick={(e) => cancelbtn(e)}>{t("cancel_txt")}</button>
                </form>
              )}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};
export default AddPromoOffers;
